import { render, staticRenderFns } from "./StagesAdd.vue?vue&type=template&id=d1ba650a&scoped=true&"
import script from "./StagesAdd.vue?vue&type=script&lang=js&"
export * from "./StagesAdd.vue?vue&type=script&lang=js&"
import style0 from "./StagesAdd.vue?vue&type=style&index=0&id=d1ba650a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ba650a",
  null
  
)

component.options.__file = "StagesAdd.vue"
export default component.exports